import React, { useState, useEffect } from "react"
import { socket } from '../../../socket';
import SocketClientFile from "../../../socketFileCLient";
import KeyboardIcon from '@mui/icons-material/Keyboard';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CollectionsIcon from '@mui/icons-material/Collections';
import CloseIcon from '@mui/icons-material/Close';

const socketUploader = new SocketClientFile(socket);

function ImageUploader({title, buttons,sendMessage,btnTypeG, setbtnTypeG, indexLength, arrayLength, scrollToBottom,openMic,messageInfo}) {
    const id = indexLength
    const [openDrawer, setOpenDrawer] = useState(false)
    const [openError, setOpenError] = useState(false)
    const [showBtn, setShowBtn] = useState(true)
    const [btnType, setbtnType] = useState("footer")
    function isMobile() {
        const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        return regex.test(navigator.userAgent);
    }
    useEffect(() => {
        if (parseInt(arrayLength?.length - 2) > indexLength) {
            setShowBtn(false)
        }
    }, [arrayLength])

    const scrollPage = () => {
        setTimeout(() => {
            scrollToBottom()
        }, 400);
    }

    const uploaderEvents = () => {
        // props.changed = true;
        // eventsCall2();
        socketUploader.on("start", function (fileInfo) {
            let obj = {
                status: "S",
                fileInfo: fileInfo,
            };
            // fileSize = fileInfo.size;
            // setStart(obj)
        });
        socketUploader.on("stream", function (fileInfo) {
            let obj = {
                status: "St",
                fileInfo: fileInfo,
            };
            // let uploadPercent = Math.round((100 * fileInfo.sent) / fileSize);
            // setProgress(uploadPercent);
            // fileSize = fileSize - fileInfo.sent;
        });
        socketUploader.on("complete", function (fileInfo) {
            let obj = {
                status: "C",
                fileInfo: fileInfo,
            };
            // setProgress(100);
            // fileSize = null;
            // setComplete(obj)
            // console.log("oiuytrfghjmvhggmj")
        });
        socketUploader.on("error", function (err, fileInfo) {
            // console.log("error in file upload", err, fileInfo);
            let obj = {
                status: "E",
                fileInfo: fileInfo,
                err: err,
            };
            // setError(obj)
        });
        socketUploader.on("abort", function (fileInfo) {
            let obj = {
                status: "A",
                fileInfo: fileInfo,
            };
            // setAbort(obj)
        });
    };

    const changeHandler = (event) => {
        // console.log(event.target.files, "filessssssss")
        const fileType = event.target.files[0]?.type
        const allowedExstension = ["image/jpeg", "image/png", "application/pdf"]
        // setSelectedFile(event.target.files[0]);
        // let imageHolder = document.getElementById(`files`+id);
        if (allowedExstension?.includes(fileType)) {
            socketUploader.upload(event.target, {
                data: { conversation_id: messageInfo?.conversationId?.Id },
            });
            uploaderEvents();
            setOpenDrawer(false)
            setShowBtn(false)
            setbtnTypeG("chat")
            // alert("successfull uploaded")
        } else {
            // alert("Not a valid file");
            setOpenError(true)
        }
    };
    return (
        <>
            {
                showBtn ?
                    btnTypeG === "chat" ?
                        isMobile() ?
                            <button type="button" className="btn-default btn-seprate" onClick={() => { setOpenDrawer(true) }}>{title}</button>
                        :
                            <>
                                <input id={`fileUploder` + id} onChange={changeHandler} class="hidden-input" type="file" accept="image/*,application/pdf,image/jpeg" />
                                <label className="btn-default btn-seprate footer-upload-label" for={`fileUploder` + id}>{title}</label>
                            </>
                    :
                        <>
                            {
                                btnType === "footer" ?
                                    <div className="appointment-footer-wrapper">
                                        {
                                            openMic ?
                                                <KeyboardVoiceIcon onClick={() => { setbtnType("chat"); setbtnTypeG("chat"); scrollPage() }} />
                                                :
                                                <KeyboardIcon onClick={() => { setbtnType("chat"); setbtnTypeG("chat"); scrollPage() }} />
                                        }
                                        {
                                            isMobile() ?
                                                <button type="button" className="btn-default btn-seprate" onClick={() => { setOpenDrawer(true) }}>{title}</button>
                                            :
                                            <>
                                                <input id={`fileUploder` + id} onChange={changeHandler} class="hidden-input" type="file" accept="image/*,application/pdf,image/jpeg" />
                                                <label className="btn-default btn-seprate footer-upload-label" for={`fileUploder` + id}>{title}</label>
                                            </>
                                        }
                                    </div>
                                    :
                                        isMobile() ?
                                            <button type="button" className="btn-default btn-seprate" onClick={() => { setOpenDrawer(true) }}>{title}</button>
                                        :
                                            <>
                                                <input id={`fileUploder` + id} onChange={changeHandler} class="hidden-input" type="file" accept="image/*,application/pdf,image/jpeg" />
                                                <label className="btn-default btn-seprate footer-upload-label" for={`fileUploder` + id}>{title}</label>
                                            </>
                            }
                        </>
                    :
                    <button type="button" className="btn-default btn-seprate btn-disabled" disabled onClick={() => setOpenDrawer(true)}>{title}</button>
            }
            {
                openDrawer ?
                    <div className="drawer-overlay" onClick={() => setOpenDrawer(false)}></div>
                    :
                    <></>
            }
            <div className={`leave-message-wrapper ${openDrawer ? "show-leave-form" : ""}`}>
                <div className="green-mark"></div>
                <div className="drawer-header">
                    {title}
                </div>
                <div className="drawer-body">
                    <div className="agent-list-wrapper">
                        <div class="mobile-uploads-grouping">
                            <input id={`cameraUploader` + id} onChange={changeHandler} class="hidden-input" type="file" accept="image/*" capture />
                            <input id={`fileUploder` + id} onChange={changeHandler} class="hidden-input" type="file" accept="image/*,application/pdf,image/jpeg" />
                            <label for={`cameraUploader` + id} class="upload-item">
                                <div class="icon-holder">
                                    <CameraAltIcon />
                                </div>
                                <div>Camera</div>
                            </label>
                            <label for={`fileUploder` + id} class="upload-item">
                                <div class="icon-holder">
                                    <CollectionsIcon />
                                </div>
                                <div>Gallery</div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            {
                openError ?
                    <div className={`about-modal-wrapper error-modal in-chat`}>
                        <div className="modal-wrapper">
                            <div className="m-header">
                                <span>Error</span>
                                <CloseIcon onClick={()=> setOpenError(false)} />
                            </div>
                            <div className="m-body">
                                <p>This file type is not supported. please upload file in (png, jpg, jpeg,pdf) format</p>
                            </div>
                        </div>
                    </div>
                :
                    <></>
            }
        </>
    )
}
export default ImageUploader